import { useDockWidgetManager } from "@slumbr/app-sdk";

import { dmsWidget } from "@/apps/messenger/dock/dms-widget";
import { gameChatWidget } from "@/apps/games/dock/game-chat-widget";

let registered = false;

/** Register shell-wide dock widgets once. DMs is always-available; game chat is
 *  contextual (only shows while a game room has registered its chat). */
export function registerShellDockWidgets(): void {
  if (registered) return;
  registered = true;
  const mgr = useDockWidgetManager.getState();
  mgr.registerWidget(dmsWidget);
  mgr.registerWidget(gameChatWidget);
}
